import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../components/atoms/button";
import Loading from "../../../components/atoms/loading";
import NavBar from "../../../components/organisms/navbar";
import useAuthenticate from "../../../hooks/useAuthenticate";
import api from "../../../services/api";
import { Content, FormContainer, PageTitle, Shake } from "../styles";
import { Box, FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useKonamiCode } from "src/utils/konamiCode";
import rulesViiiLijjamCombatDeJiuJitsu2025Gi from "../../../data/rules-viii-lijjam-combat-de-jiu-jitsu-2025-gi.json";
import NoOptionsAlert from "src/components/atoms/no-options-alert";
import SelectCategories from "src/components/atoms/selectCategories";
import Input from "src/components/atoms/input";
import { getValue } from "@testing-library/user-event/dist/utils";
interface EnrollmentData {
  id: number;
  tournamentId: number;
  valueSubscription: string;
  age: string;
  belt: string;
  category: string;
  created_at: string;
  updated_at: string;
  status: boolean;
  fighters: null | any; // Define o tipo de 'fighters' como 'null' ou 'any'
  fightersId: null | any; // Define o tipo de 'fightersId' como 'null' ou 'any'
  genre: string;
  user: {
    id: number;
    name: string;
    email: string;
    birth_date: string;
    genre: string;
    gym: string;
    mother_name: string;
    status: boolean;
  };
  weight: string;
}
const EnrollmentUpdateViiiLijjamCombatDeJiuJitsu2025 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getToken, account } = useAuthenticate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    getValues,
    watch } = useForm();

  const modalidade = [
    { title: "Sim", option: 1 },
    { title: "Não", option: 0 },
  ];
  const { id, slug } = useParams();
  let rules = rulesViiiLijjamCombatDeJiuJitsu2025Gi;

  const [selectedData, setSelectedData] = useState<EnrollmentData>();
  const from = location.state?.from || '/profile/subscription';
  const mode = location.state?.mode || "";
  const isLivre = mode === "livre";
  const [ages, setAges] = useState<any>();
  const [genre, setGenre] = useState<any>();
  const [belts, setBelts] = useState<any>();
  const [weightKg, setWeightKg] = useState<any>();
  const [disabled, setDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [noCategoriesAvailable, setNoCategoriesAvailable] = useState<boolean>(false);
  const [rawWeights, setRawWeights] = useState<any>([]);
  const [rawCategories, setRawCategories] = useState<any>([]);
  const [autoCategory, setAutoCategory] = useState<any>([]);
  const [shakeTrigger, setShakeTrigger] = useState(0);
  const [tournament, setTournament] = useState<any>({});
  const lastValidGiWeightRef = useRef<string>("");

  const beltsData = [
    { title: "Selecione uma opção", option: "" },
    { title: "BRANCA", option: "branca" },
    { title: "CINZA", option: "cinza" },
    { title: "AMARELA", option: "amarela" },
    { title: "LARANJA", option: "laranja" },
    { title: "VERDE", option: "verde" },
    { title: "AZUL", option: "azul" },
    { title: "ROXA", option: "roxa" },
    { title: "MARROM", option: "marrom" },
    { title: "PRETA", option: "preta" },
  ];

  const genreData = [
    { title: "Selecione uma opção", option: "" },
    { title: "MASCULINO", option: "masculino" },
    { title: "FEMININO", option: "feminino" },
  ]

  const norm = (s: any) =>
    String(s ?? "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, ""); // remove acentos

  // montar todos as categorias (modo livre)
  const buildAllCategories = () => {
    const categories = rules.map((r: any) => r.categoria);
    const unique = Array.from(new Set(categories));
    return [
      { title: "Selecione uma opção", option: "" },
      ...unique.map((c) => ({
        title: String(c).toUpperCase(),
        option: c,
      })),
    ];
  };

  const buildAllWeights = () => {
    const weights = rules.map((r: any) => r.peso);
    const unique = Array.from(new Set(weights.map(item => item.descricao)));

    return [
      { title: "Selecione uma opção", option: "" },
      ...unique.map((c) => ({
        title: String(c).toUpperCase(),
        option: c,
      })),
    ];
  };

  const getUrl = (account: any, slug: string | undefined, authorId: any) => {
    if (account?.roles?.includes("manager")) {
      return `/administrators/tournaments/enrollments/${id}`;
    }

    if (authorId === account?.id) {
      return `/managers/tournaments/enrollments/${id}`;
    }

    return `/tournaments/enrollments/${id}`;
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {

    if (!account) return;

    api.get(`tournaments/${slug}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then(({ data }) => {
        setTournament(data)
      })
      ;

    if (!account) return;

    const url = getUrl(account, slug, tournament.authorId);

    setLoading(true);
    api
      .get(url, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);

        // Encontre o objeto com o ID correspondente e armazene-o em 'selectedData'
        setSelectedData(data);
        applyFighterLogic(data);

      })
      .catch((error) => {
        setLoading(false);
        toast.error("Não foi possível carregar os dados de inscrições.");
      });
  }, [account]);

  function encontrarCategoria(valor: number) {

    if (!Array.isArray(rawWeights) || rawWeights.length === 0) {
      return { peso: undefined, massa: undefined, limite: Infinity };
    }

    // por padrão, assume a última categoria (ex.: pesadíssimo)
    let selecionada = rawWeights[rawWeights.length - 1];
    let limite = Infinity;

    // helper: extrai números aceitando "," ou "."
    const extrairNumeros = (s: string): number[] => {
      // pega 12,3 | 12.3 | 12
      const matches = s.match(/(\d+(?:[.,]\d+)?)/g) || [];
      return matches.map((m) => parseFloat(m.replace(",", ".")));
    };

    console.log(rawWeights);

    for (const cat of rawWeights) {
      const massa = String(cat?.massa || "").toLowerCase().trim();
      if (!massa) continue;

      const nums = extrairNumeros(massa);
      if (nums.length === 0) continue;

      // 1) "até X"
      if (massa.includes("até")) {
        const max = nums[nums.length - 1]; // último número
        if (valor <= max) {
          selecionada = cat;
          limite = max;
          break;
        }
        continue;
      }

      // 2) "acima de X" / "maior que X"
      if (massa.includes("acima") || massa.includes("maior")) {
        const min = nums[nums.length - 1];
        if (valor >= min) {
          selecionada = cat;
          limite = Infinity;
          break;
        }
        continue;
      }

      // 3) "de X a Y" / "entre X e Y"
      if (massa.includes("de") && (massa.includes("a ") || massa.includes(" e "))) {
        const [min, max] = nums.length >= 2 ? [nums[0], nums[1]] : [nums[0], nums[0]];
        if (valor >= min && valor <= max) {
          selecionada = cat;
          limite = max;
          break;
        }
        continue;
      }

      // fallback: se vier só um número sem palavras-chave, trata como "até X"
      if (nums.length === 1) {
        const max = nums[0];
        if (valor <= max) {
          selecionada = cat;
          limite = max;
          break;
        }
      }
    }

    return { ...selecionada, limite };
  }

  const applyFighterLogic = async (subscription: any) => {
    try {
      // ==== 1) Extrai e normaliza os filtros base ====
      const genreRaw = subscription?.genre;
      const ageRaw = +subscription?.age;
      const beltRaw = subscription?.belt;
      const weightKg = subscription?.weight;
      const match = weightKg.match(/\d+(?:[.,]\d+)?/);
      const numero = match ? match[0] : null;
      const genero = norm(genreRaw);
      const idade = Number.isFinite(ageRaw) ? ageRaw : NaN;
      const faixa = norm(beltRaw);
      const teste = subscription.weight.split(';')[1].toLowerCase().trim()

      console.log(teste);

      setWeightKg(numero);
      setValue('genre', genero)
      setValue('age', idade)
      setValue('belt', beltRaw)
      setValue('category', subscription.category.replace(/^pcd -\s*/i, ""))
      setValue('weight', teste)

      if (mode === "livre") {
        // sem regras: mostra tudo
        setRawCategories(buildAllCategories());
        setRawWeights(buildAllWeights());
        setNoCategoriesAvailable(false);
        return;
      }

      if (!Number.isFinite(idade) || !genero || !faixa) {
        setNoCategoriesAvailable(true);
        setAutoCategory(undefined);
        setRawWeights([]);
        return;
      }

      // ==== 2) Coleta categorias válidas ====
      const categoriasElegiveis: Array<{
        item: string;
        min: number;
        max: number;
        maxDescricao: number;
        minDescricao: number;
        descricaoCompleta: string;
      }> = [];

      for (const item of rules) {
        const generoItem = norm(item.genero);
        const faixaOk = Array.isArray(item.faixa) &&
          item.faixa.some((f: any) => norm(f?.nome) === faixa);

        if (
          item.idade?.min <= idade &&
          item.idade?.max >= idade &&
          generoItem === genero &&
          faixaOk
        ) {
          categoriasElegiveis.push({
            item: item.categoria, // mantém como está no JSON
            min: item.idade.min,
            max: item.idade.max,
            maxDescricao: item.idade.maxParaDescricao,
            minDescricao: item.idade.minParaDescricao,
            descricaoCompleta: item.idade.descricaoCompleta,
          });
        }
      }

      if (categoriasElegiveis.length === 0) {
        setNoCategoriesAvailable(true);
        setAutoCategory(undefined);
        setRawWeights([]);
        return;
      } else {
        setNoCategoriesAvailable(false);
      }

      // Escolhe uma (a sua lógica anterior usava a última)
      const categoriaEscolhida = categoriasElegiveis[categoriasElegiveis.length - 1];
      setAutoCategory(categoriaEscolhida); // ok setar; mas NÃO usar o estado agora

      // ==== 3) Coleta pesos COM base na categoria local (sem depender do estado) ====
      const pesosElegiveis: Array<{ peso: string; massa: string }> = [];

      for (const item of rules) {
        const generoItem = norm(item.genero);
        const faixaOk = Array.isArray(item.faixa) &&
          item.faixa.some((f: any) => norm(f?.nome) === faixa);

        // compara categoria exatamente com a selecionada (mesma string do JSON)
        const mesmaCategoria = String(item.categoria) === String(categoriaEscolhida.item);

        if (
          item.idade?.min <= idade &&
          item.idade?.max >= idade &&
          generoItem === genero &&
          mesmaCategoria &&
          faixaOk
        ) {
          pesosElegiveis.push({
            peso: item.peso.descricao,
            massa: item.peso.max,
          });
        }
      }

      if (pesosElegiveis.length === 0) {
        setNoCategoriesAvailable(true);
        setRawWeights([]);
        return;
      }

      setRawWeights(pesosElegiveis);
    } catch (err) {
      console.error("applyFighterLogic error:", err);
      setNoCategoriesAvailable(true);
      setAutoCategory(undefined);
      setRawWeights([]);
    }
  };

  const handleChangeWeights = (category: string | null) => {
    setValue("weight", '');
    console.log('chaiusdhasih')
    // ==== 3) Coleta pesos COM base na categoria local (sem depender do estado) ====
    const pesosElegiveis: Array<{ peso: string; massa: string }> = [];
    for (const item of rules) {
      const generoItem = norm(item.genero);

      if (
        item.idade.max >= +ages &&
        item.idade.min <= +ages &&
        generoItem === genre &&
        item.categoria === category
      ) {
        pesosElegiveis.push({
          peso: item.peso.descricao,
          massa: item.peso.max
        })
      }

    }

    const unique = Array.from(new Set(pesosElegiveis));

    const pesosUnicos = unique.map(pes => {
      return {
        title: `${pes.peso} - ${pes.massa}`.toUpperCase(),
        option: pes.peso
      }
    })

    setRawWeights([
      {
        title: "Selecione uma opção",
        option: "",
      },
      ...pesosUnicos
    ]);

  };

  const onSubmit = (data: any) => {
    console.log(data);
    setDisabled(true);
    setLoading(true);

    // Verificando se `modalidade` é uma string ou número e ajustando a comparação
    const category = isLivre ? +data.modalidade === 1 ? "pcd - " + data.category : +data.modalidade === 0 ? data.category : "" : +data.modalidade === 1
      ? "pcd - " + autoCategory.item
      : +data.modalidade === 0
        ? autoCategory.item
        : "";;

    api
      .patch(
        `/tournaments/enrollments/${id}`,
        {
          //...data,
          slug: slug,
          age: String(data.age),
          belt: data.belt,
          genre: data.genre,
          weight: !isLivre ? `${data?.inputWeightKg} kg; ${data?.weight?.peso}` : data.inputWeightKg ? data.inputWeightKg + ` KG; ${data.weight}` : weightKg + ` KG; ${data.weight}`,
          category: category,
          fightersId: selectedData?.fightersId!,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then(() => {
        toast.success("A sua atualização da inscrição foi realizada com sucesso!");

        setTimeout(() => {
          navigate(from);
        }, 2000);
      })
      .catch((error) => {
        setDisabled(false);
        setLoading(false);
        toast.error(error?.data?.message || "Não foi possível gerar a sua atualização da inscrição!");
      });
  };

  useEffect(() => {

    if (isLivre) {
      register("weight", {
        required: "Selecione seu peso.",
      });
      register("category", {
        required: "Selecione uma categoria.",
      });
    }

    register("modalidade", {
      required: "Selecione uma modalidade.",
    });


  }, [register]);

  if (loading)
    return <Loading text="Aguarde, estamos processando a sua pré-inscrição." />;

  return (
    <div>
      <NavBar />
      <Content>
        <FormContainer onSubmit={handleSubmit(onSubmit, () => {
          // Reinicia a animação se houver erro
          setShakeTrigger(prev => prev + 1);
        })}>

          <PageTitle>
            Atualização de Inscrição Nº {id}
          </PageTitle>

          <Typography sx={{ fontWeight: 500, fontSize: '1.1rem' }}>
            Nome: {selectedData?.fighters ? selectedData?.fighters?.name?.toLocaleUpperCase() : selectedData?.user?.name?.toLocaleUpperCase()}
          </Typography>

          <Typography sx={{ fontWeight: 500, fontSize: '1.1rem' }}>
            Idade de luta (dessa inscrição): {selectedData?.age?.toUpperCase?.() + ' anos' || 'N/A'}
          </Typography>

          <Typography sx={{ fontWeight: 500, fontSize: '1.1rem', mb: 2 }}>
            Categoria atual:  {selectedData?.category.toLocaleUpperCase()} / {selectedData?.genre.toLocaleUpperCase()} / {selectedData?.belt.toLocaleUpperCase()} / {selectedData?.weight.split(';')[1].toLocaleUpperCase()}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 1 }}>

            {/* Gênero */}
            {isLivre && (
              <SelectCategories
                label="Gênero:"
                name="genre"
                register={register}
                required
                hasError={!!errors.genre}
                error={typeof errors.genre?.message === "string" ? errors.genre.message : "Este campo é obrigatório"}
                options={genreData}
              />
            )}

            {/* Gênero */}
            {isLivre && (
              <Input
                label="Idade de luta:"
                placeholder="Digite uma idade"
                name="age"
                type="number"
                register={register}
                required
                hasError={!!errors.age}
                error="Este campo é obrigatório"
              />
            )}

            {/* Faixa */}
            {isLivre && (
              <SelectCategories
                label="Faixa:"
                name="belt"
                register={register}
                required
                hasError={!!errors.belt}
                error={typeof errors.belt?.message === "string" ? errors.belt.message : "Este campo é obrigatório"}
                options={beltsData}
              />
            )}


            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <NoOptionsAlert
                show={noCategoriesAvailable}
                type="categories"
                fighterData={{
                  name: selectedData?.fighters
                    ? selectedData?.fighters?.name
                    : selectedData?.user?.name,
                  age: getValues('age'),
                  gender: getValues('genre')?.toUpperCase(),
                  belt: getValues('belt')?.toUpperCase(),
                }}
              />
            </Box>
          </Box>

          {isLivre && (
            <>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                  sx={{
                    animation: !!errors.category ? `${Shake} 0.3s ease-in-out` : "none",
                  }}
                >
                  <SelectCategories
                    label="Categoria de idade:"
                    name="category"
                    register={register}
                    required
                    hasError={!!errors.category}
                    error="Este campo é obrigatório"
                    options={rawCategories}
                    onChange={!isLivre ? () => handleChangeWeights(getValues('category')) : undefined}
                  />
                </Box>

                <SelectCategories
                  label="Categoria de peso:"
                  name="weight"
                  register={register}
                  required
                  hasError={!!errors.weight}
                  error="Este campo é obrigatório"
                  options={rawWeights}
                />

                <Box
                  sx={{
                    animation: !!errors.weight ? `${Shake} 0.3s ease-in-out` : "none",
                  }}
                >
                  <Controller
                    name="inputWeightKg"
                    control={control}
                    render={({ field, fieldState }) => (
                      <TextField
                        key={shakeTrigger}
                        {...field}
                        label="Seu peso (kg)"
                        fullWidth
                        defaultValue={weightKg}
                        variant="outlined"
                        placeholder="0,0"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        sx={{
                          animation: fieldState.error ? `${Shake} 0.3s ease-in-out` : "none",
                          mt: 2,
                          mb: 2,
                          fontFamily: 'inter, sans-serif',
                        }}
                        onChange={(e) => {
                          let raw = e.target.value.replace(/\D/g, "");
                          if (raw.length > 4) raw = raw.slice(0, 4);

                          if (raw === "") {
                            field.onChange("");
                            setValue("inputWeightKg", "");
                            lastValidGiWeightRef.current = "";
                            return;
                          }

                          let formatted = "";
                          if (raw.length === 1) {
                            formatted = `0,${raw}`;
                          } else {
                            const intPart = raw.slice(0, -1);
                            const decimal = raw.slice(-1);
                            formatted = `${parseInt(intPart, 10)},${decimal}`;
                          }

                          const parsed = Number(formatted.replace(",", "."));
                          if (parsed > 999.9) {
                            formatted = "999,9";
                          }

                          field.onChange(formatted);
                          lastValidGiWeightRef.current = formatted;

                          if (Number.isFinite(parsed)) {
                            setValue("inputWeightKg", String(formatted) || "");
                          } else {
                            setValue("inputWeightKg", "");
                          }
                        }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                          inputMode: "numeric",
                        }}
                      />
                    )}
                  />
                </Box>

                <FormControl
                  component="fieldset"
                  error={!!errors.modalidade}
                  sx={{
                    animation: !!errors.modalidade ? `${Shake} 0.3s ease-in-out` : "none",
                  }}
                >
                  <FormLabel component="legend" style={{ color: "#33303E" }}>
                    Pessoa com deficiência - PcD?
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="PcD"
                    value={watch("modalidade")}
                    sx={{
                      mt: 1,
                      mb: 1
                    }}
                    onChange={(e) =>
                      setValue("modalidade", e.target.value, { shouldValidate: true })
                    }
                  >
                    {modalidade.map((m) => (
                      <FormControlLabel
                        key={m.option}
                        value={String(m.option)}
                        control={<Radio color="error" />}
                        label={m.title}
                      />
                    ))}
                  </RadioGroup>
                  <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                    {typeof errors.modalidade?.message === "string"
                      ? errors.modalidade.message
                      : ""}
                  </Typography>
                </FormControl>
              </Box>

              <Button type="submit" label="Editar inscrição" disabled={disabled} />
            </>
          )}

          {!isLivre && !noCategoriesAvailable && (
            <>
              <Controller
                name="inputWeightKg"
                control={control}
                rules={{ required: "Informe seu peso." }}
                render={({ field, fieldState }) => (
                  <TextField
                    key={shakeTrigger}
                    {...field}
                    label="Seu peso (kg)"
                    fullWidth
                    variant="outlined"
                    placeholder="0,0"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    sx={{
                      animation: fieldState.error ? `${Shake} 0.3s ease-in-out` : "none",
                      mb: 2
                    }}
                    onChange={(e) => {
                      let raw = e.target.value.replace(/\D/g, "");
                      if (raw.length > 4) raw = raw.slice(0, 4);

                      if (raw === "") {
                        field.onChange("");
                        setValue("weight", "");
                        lastValidGiWeightRef.current = "";
                        return;
                      }

                      let formatted = "";
                      if (raw.length === 1) {
                        formatted = `0,${raw}`;
                      } else {
                        const intPart = raw.slice(0, -1);
                        const decimal = raw.slice(-1);
                        formatted = `${parseInt(intPart, 10)},${decimal}`;
                      }

                      const parsed = Number(formatted.replace(",", "."));
                      if (parsed > 999.9) {
                        formatted = "999,9";
                      }

                      field.onChange(formatted);
                      lastValidGiWeightRef.current = formatted;

                      if (Number.isFinite(parsed)) {
                        const categoria = encontrarCategoria(parsed);
                        setValue("weight", categoria || "");
                      } else {
                        setValue("weight", "");
                      }
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                      inputMode: "numeric",
                    }} />
                )} />
              <FormControl
                component="fieldset"
                error={!!errors.modalidade}
                sx={{
                  animation: !!errors.modalidade ? `${Shake} 0.3s ease-in-out` : "none",
                }}
              >
                <FormLabel component="legend" style={{ color: "#33303E" }}>
                  Pessoa com deficiência - PcD?
                </FormLabel>
                <RadioGroup
                  row
                  sx={{
                    mb: 1
                  }}
                  aria-label="PcD"
                  value={watch("modalidade")}
                  onChange={(e) => setValue("modalidade", e.target.value, { shouldValidate: true })}
                >
                  {modalidade.map((m) => (
                    <FormControlLabel
                      key={m.option}
                      value={String(m.option)}
                      control={<Radio color="error" />}
                      label={m.title} />
                  ))}
                </RadioGroup>
                <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                  {typeof errors.modalidade?.message === "string"
                    ? errors.modalidade.message
                    : ""}
                </Typography>
              </FormControl>
              <Button type="submit" label="Editar inscrição" disabled={disabled} />
            </>
          )}
        </FormContainer>
      </Content>
    </div >
  );
};
export default EnrollmentUpdateViiiLijjamCombatDeJiuJitsu2025;